export default {"src":"/_next/static/media/POL.a145dcbe.svg","height":47,"width":52,"blurWidth":0,"blurHeight":0};